import { useRef } from "react";
import { PlayCircle } from "lucide-react";
import { api } from "@/lib/api";

const WA_TEXT = "🎬 Guarda questo video di 60 secondi: ti spiega quanto vale DAVVERO la tua casa — con le quotazioni ufficiali OMI, non con i prezzi gonfiati dei portali. Valutazione gratuita in 2 minuti 👉 https://eneaspecialist.it";

export default function VideoGuide({ page }) {
  const tracked = useRef(false);
  const onPlay = () => {
    if (tracked.current) return;
    tracked.current = true;
    api.post("/video-play", { page }).catch(() => {});
  };
  const shareWhatsApp = () => {
    api.post("/share-event", { channel: "whatsapp", protocol_code: `VIDEO-${page.toUpperCase()}` }).catch(() => {});
    window.open(`https://wa.me/?text=${encodeURIComponent(WA_TEXT)}`, "_blank", "noopener");
  };
  return (
    <div className="rounded-2xl bg-white border border-slate-200 shadow-lg shadow-slate-200/50 overflow-hidden" data-testid={`video-guide-${page}`}>
      <div className="px-5 py-3 bg-[#0b2545] flex items-center gap-2.5">
        <PlayCircle className="w-5 h-5 text-[#14B8A6] flex-shrink-0" />
        <div>
          <p className="text-sm font-semibold text-white leading-tight">Il Filtro d'Ingresso in 60 secondi</p>
          <p className="text-[11px] text-[#A9D6E5]">Guarda perché questa non è la solita valutazione: dati OMI reali, rischio di zona e protocollo Zero Vincoli.</p>
        </div>
      </div>
      <video
        controls
        playsInline
        preload="none"
        poster="/video-guida-poster.jpg?v=7"
        onPlay={onPlay}
        className="w-full aspect-video bg-[#0b2545]"
        data-testid={`video-player-${page}`}
      >
        <source src="/video-guida-valutazione.mp4?v=7" type="video/mp4" />
        <source src="/video-guida-valutazione.webm?v=7" type="video/webm" />
        <track kind="subtitles" srcLang="it" label="Italiano" src="/video-guida-valutazione.vtt?v=7" default />
        Il tuo browser non supporta i video HTML5.
      </video>
      <div className="px-4 py-2.5 bg-slate-50 border-t border-slate-200 flex items-center justify-between gap-3 flex-wrap">
        <p className="text-[11px] text-slate-500">Conosci qualcuno che sta vendendo casa? Mandagli il video.</p>
        <button
          type="button"
          onClick={shareWhatsApp}
          className="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full bg-[#25D366] hover:bg-[#1fbd5a] text-white text-xs font-bold transition-colors"
          data-testid={`video-share-whatsapp-${page}`}
        >
          <svg viewBox="0 0 24 24" className="w-3.5 h-3.5" fill="currentColor" aria-hidden="true">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
          </svg>
          Condividi su WhatsApp
        </button>
      </div>
    </div>
  );
}
